import { getNextApiRoute, typedFetch } from '@libs/common-next';
import { HttpMethod } from '@libs/core';

import type { OrdergrooveSubscriptions } from '../types';

export const getUserHasActiveSubscriptions = async (sid: string) => {
    return await typedFetch<OrdergrooveSubscriptions>(getNextApiRoute(`auto-ship/subscriptions/${sid}`), {
        method: HttpMethod.GET,
        headers: {
            'content-type': 'application/json',
        },
    });
};

export const getAutoshipSubscriptions = async () => {
    return typedFetch<{ count: number }>(getNextApiRoute('autoship/subscriptions'), {
        method: HttpMethod.GET,
        headers: {
            'content-type': 'application/json',
        },
    });
};
